import angular from 'angular';
import loaderComponent from './loader.component';

const loaderModule = angular.module('loader', [])
    .component('loader', loaderComponent)
    .name;

export default loaderModule;



// WEBPACK FOOTER //
// ./client/app/common/loader/loader.js